// List of realms from RealmEnum.js
const realms = [
  "Icecrown",
  "Lordaeron",
  "Frostmourne",
  "Blackrock",
  "Onyxia",
];
export default realms;
